import React, { useEffect, useState } from 'react'
import { useMergeState } from '../../../irmlib/src/hooks'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { setBusy, clearBusy } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'
import { Box, FormControl } from '@mui/material'
import { OutlinedButton } from 'irmlib/components/Controls'
// import Dropdown from '../../../irmlib/src/components/Controls/Dropdown'
// import GroupedAssetType from '../../../irmlib/src/components/Controls/GroupedAssetType'
import { useHistory, useLocation } from 'react-router-dom'
import { persistFilters, getUser } from '../../../redux/global'
import * as routePaths from '../../../navigation/routePaths'
// import { Autocomplete, TextField } from '@mui/material'
import { CheckboxMultiselect } from '../../../irmlib/src/components/FormControls/Filter'
import * as gdeTransactionsLite from '../../../services/firestore/gdeTransactionsLite'
import PropTypes from 'prop-types'
// import { useLocation } from 'react-router-dom'

const initialSate = {
  loggedInDistrict: '',
  country: '',
  templateTypeList: [],
  districtsList: [],
  selectedValue: {},
  selectedStatus: {},
}

const BoxTransmittalFilter = (props) => {
  // eslint-disable-next-line
  const [state, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const userval = getUser()
  const { workerId, country, district } = userval
  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const viewTransmittals = pathParams[1]
  const [searchBtnDisabled, setSearchBtnDisabled] = useState(true)

  const getDistricts = async (country = '') => {
    setBusy()
    let collection
    if (country) {
      collection = await gdeTransactions.getDistrictsByCountry(country)
    } else {
      collection = await gdeTransactions.getDistricts()
    }
    const districtsList = []
    collection?.forEach((doc) => {
      districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
    })
    setState({ districtsList: districtsList })
    clearBusy()
  }

  useEffect(() => {
    // const { workerId, district, country } = getUser()
    const { district, country } = getUser()
    setState({ loggedInDistrict: district, country: country })
    getTemplateTypes()
    getDistricts(country)
  }, [])

  const getTemplateTypes = async () => {
    setBusy()
    const collection = await gdeTransactionsLite.getTemplateTypesForWms('SKP')
    const templateTypes = []
    collection.forEach((doc) => {
      templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
    })
    setState({ templateTypeList: templateTypes })
    clearBusy()
  }

  const handleCLick = () => {
    if (Object.keys(state?.selectedValue).length === 0) {
      setState({ selectedValue: { District: finalDist } })
      props.selectedData({ ...state.selectedValue, ...state.selectedStatus })
    } else {
      props.selectedData({ ...state.selectedValue, ...state.selectedStatus })
    }
    const storedData = localStorage.getItem('persistFilters')
    const existingData = storedData ? JSON.parse(storedData) : {}
    if (!existingData[viewTransmittals]) {
      existingData[viewTransmittals] = {}
    }
    existingData[viewTransmittals] = {
      workerId: workerId,
      country: country,
      district: state.selectedValue?.District || [district],
      status: state.selectedStatus?.Status || props.defaultStatus
    }
    localStorage.setItem('persistFilters', JSON.stringify(existingData))
  }
  const history = useHistory()

  const onClick = (route) => {
    history.push(route)
  }
  const handleSelectedData = (data) => {
    setSearchBtnDisabled(false)
    setState({ selectedValue: data })
  }
  
  const handleSelectedStatus = (data) => {
    setSearchBtnDisabled(false)
    setState({ selectedStatus: data })
  }

  const defDistricts = persistFilters()?.district?.length ? persistFilters()?.district : [district]

  let finalDist

  if (Object.keys(state?.selectedValue).length === 0) {
    finalDist = defDistricts
  } else {
    finalDist = getState()?.selectedValue?.District
  } 

  return (
    <>
      <CheckboxMultiselect
        options={state.districtsList}
        defaultOption={finalDist}
        label={t('Search.District')}
        handleSelect={handleSelectedData}
        name='District'
      />
      {props.activeStatus && props.defaultStatus &&
        <CheckboxMultiselect
          options={props.activeStatus}
          defaultOption={props.defaultStatus}
          label={t('Search.Status')}
          handleSelect={handleSelectedStatus}
          name='Status'
        />}
      <FormControl sx={{ m: 1, width: 'fitContent', display: 'flex', justifyContent: 'center' }}>
        <OutlinedButton id={'allJobs_createJob'} disabled={searchBtnDisabled} variant='contained' onClick={handleCLick}>
          forms.Search
        </OutlinedButton>
      </FormControl>
      {getUser().role !== '1SUPER USER'
        ? <Box component='div' sx={{ display: 'flex', marginLeft: 'auto' }}>
          <FormControl
            sx={{ m: 1, width: 'fitContent', display: 'flex', justifyContent: 'center' }}
            size={'small'}
          >
            <OutlinedButton
              sx={{ height: '50px' }}
              id={'Box_addTransmittal'}
              variant='contained'
              onClick={() => onClick(routePaths.addBoxTransmittals)}
            >
              {t('smartCatalog.addBoxTransmittals').toUpperCase()}
            </OutlinedButton>
          </FormControl>
          <FormControl
            sx={{ m: 1, width: 'fitContent', display: 'flex', justifyContent: 'center' }}
            size={'small'}
          >
            <OutlinedButton
              sx={{ height: '50px' }}
              id={'Box_addTransmittal'}
              variant='outlined'
              onClick={() => onClick(routePaths.uploadBoxTransmittals)}
            >
              {t('smartCatalog.uploadBt').toUpperCase()}
            </OutlinedButton>
          </FormControl>
        </Box>
        : null}
    </>
  )
}

BoxTransmittalFilter.propTypes = {
  defaultStatus: PropTypes.array,
  activeStatus: PropTypes.array,
  selectedData: PropTypes.func
}

export default BoxTransmittalFilter
